import { cn } from "@/lib/utils";
import { LOGO_BOX_CLASS } from "@/lib/branding";

/**
 * Company logo. Fixed 0.5 in / 48 × 48 px square — the org-wide branding
 * size. Today it's the "UH" wordmark; swap to an <img> here once a real
 * brand asset ships in /public.
 */
export function CompanyLogo({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        LOGO_BOX_CLASS,
        "flex items-center justify-center rounded-lg bg-zinc-900",
        className,
      )}
      aria-label="Ultrahuman HRMS"
    >
      <span className="text-sm font-black text-white">UH</span>
    </div>
  );
}

export default CompanyLogo;
